module.exports = __webpack_public_path__ + "img/Replace card.574785a7.svg";